import { useMemo, useState } from "react";
import { CheckCircle2, Search } from "lucide-react";

import { Modal } from "@/components/modal";
import { Button } from "@/components/ui";
import { slug } from "@/lib/format";

export function SelectDialog({ open, onClose, title, options, value, onChange, multi = false, testId }) {
  const [q, setQ] = useState("");
  const filtered = useMemo(() => options.filter((o) => o.toLowerCase().includes(q.toLowerCase())), [options, q]);
  const pick = (o) => {
    if (!multi) {
      onChange([o]);
      onClose();
      return;
    }
    onChange(value.includes(o) ? value.filter((v) => v !== o) : [...value, o]);
  };
  return (
    <Modal open={open} onClose={onClose} title={title} testId={testId}>
      <label className="mb-3 flex h-12 items-center gap-2 rounded-xl bg-[#F4EBE6] px-4">
        <Search className="h-[18px] w-[18px] text-muted-foreground" />
        <input data-testid={`${testId}-search`} aria-label="Search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search" className="flex-1 bg-transparent text-[15px] outline-none" />
      </label>
      <ul className="max-h-[380px] overflow-y-auto" role="listbox">
        {filtered.map((o) => {
          const on = value.includes(o);
          return (
            <li key={o}>
              <button type="button" data-testid={`${testId}-option-${slug(o)}`} onClick={() => pick(o)} className="flex h-12 w-full items-center justify-between rounded-lg border-b border-border px-2 text-left text-[15px] hover:bg-[#FDFBF7]">
                <span className={on ? "font-bold text-primary" : ""}>{o}</span>
                {on ? <CheckCircle2 className="h-5 w-5 text-primary" /> : null}
              </button>
            </li>
          );
        })}
      </ul>
      {multi ? (
        <div className="mt-4 flex gap-3">
          <Button testId={`${testId}-clear`} title="No preference" variant="outline" className="flex-1" onClick={() => onChange([])} />
          <Button testId={`${testId}-done`} title="Done" className="flex-1" onClick={onClose} />
        </div>
      ) : null}
    </Modal>
  );
}
